import { Component } from '@angular/core';

@Component({
  selector: 'app-rl',
  templateUrl: './required-label.component.html',
  styleUrls: ['./required-label.component.scss']
})
export class RequiredLabelComponent {

}
